import React, { useState, useEffect } from 'react';
import { Save, Loader2 } from 'lucide-react';
import { getData, setData } from '../services/storage';
import { Button } from '../components/Forms';

const DEFAULT = {
  companyName: '', mobile: '', whatsapp: '', email: '', supportEmail: '',
  address: '', googleMapLink: '',
  businessHours: { weekday: '', saturday: '', sunday: '' },
  socialLinks: { whatsapp: '', instagram: '', facebook: '', youtube: '', twitter: '', linkedin: '' },
};

const ContactInfo = () => {
  const [form, setForm] = useState(DEFAULT);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const data = getData('contact');
    if (data) setForm({ ...DEFAULT, ...data, socialLinks: { ...DEFAULT.socialLinks, ...(data.socialLinks || {}) } });
    setLoading(false);
  }, []);

  const handleChange = (field, value) => setForm(f => ({ ...f, [field]: value }));
  const handleSocialChange = (key, value) => setForm(f => ({ ...f, socialLinks: { ...f.socialLinks, [key]: value } }));
  const handleHoursChange = (key, value) => setForm(f => ({ ...f, businessHours: { ...f.businessHours, [key]: value } }));

  const handleSubmit = (e) => {
    e.preventDefault();
    setSaving(true);
    setSuccess('');
    setData('contact', form);
    console.log('[Contact] Saved contact information');
    setSuccess('Contact information updated successfully!');
    setTimeout(() => setSuccess(''), 3000);
    setSaving(false);
  };

  if (loading) return <div className="flex justify-center py-16"><Loader2 className="animate-spin text-purple-500" size={32} /></div>;

  const Field = ({ label, value, onChange, type = 'text', placeholder = '' }) => (
    <div>
      <label className="block text-sm font-medium text-slate-700 mb-1.5">{label}</label>
      {type === 'textarea' ? (
        <textarea value={value} onChange={(e) => onChange(e.target.value)} rows={3}
          className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20 outline-none text-sm resize-none" placeholder={placeholder} />
      ) : (
        <input type={type} value={value} onChange={(e) => onChange(e.target.value)}
          className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20 outline-none text-sm" placeholder={placeholder} />
      )}
    </div>
  );

  return (
    <div>
      {success && <div className="bg-emerald-50 border border-emerald-200 text-emerald-700 px-4 py-3 rounded-lg text-sm mb-6">{success}</div>}
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
          <h3 className="text-base font-semibold text-slate-800 mb-4">Basic Information</h3>
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label="Company Name" value={form.companyName} onChange={(v) => handleChange('companyName', v)} />
            <Field label="Mobile Number" value={form.mobile} onChange={(v) => handleChange('mobile', v)} />
            <Field label="WhatsApp Number" value={form.whatsapp} onChange={(v) => handleChange('whatsapp', v)} />
            <Field label="Email Address" type="email" value={form.email} onChange={(v) => handleChange('email', v)} />
            <Field label="Support Email" type="email" value={form.supportEmail} onChange={(v) => handleChange('supportEmail', v)} placeholder="support@skymuse.in" />
          </div>
          <div className="mt-4">
            <Field label="Office Address" type="textarea" value={form.address} onChange={(v) => handleChange('address', v)} />
          </div>
          <div className="mt-4">
            <Field label="Google Map Link" value={form.googleMapLink} onChange={(v) => handleChange('googleMapLink', v)} placeholder="https://maps.google.com/..." />
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
          <h3 className="text-base font-semibold text-slate-800 mb-4">Business Hours</h3>
          <div className="grid sm:grid-cols-3 gap-4">
            <Field label="Weekdays" value={form.businessHours.weekday} onChange={(v) => handleHoursChange('weekday', v)} placeholder="10:00 AM - 7:00 PM" />
            <Field label="Saturday" value={form.businessHours.saturday} onChange={(v) => handleHoursChange('saturday', v)} placeholder="10:00 AM - 5:00 PM" />
            <Field label="Sunday" value={form.businessHours.sunday} onChange={(v) => handleHoursChange('sunday', v)} placeholder="Closed" />
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
          <h3 className="text-base font-semibold text-slate-800 mb-4">Social Media Links</h3>
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label="WhatsApp Link" value={form.socialLinks.whatsapp} onChange={(v) => handleSocialChange('whatsapp', v)} />
            <Field label="Instagram" value={form.socialLinks.instagram} onChange={(v) => handleSocialChange('instagram', v)} />
            <Field label="Facebook" value={form.socialLinks.facebook} onChange={(v) => handleSocialChange('facebook', v)} />
            <Field label="YouTube" value={form.socialLinks.youtube} onChange={(v) => handleSocialChange('youtube', v)} />
            <Field label="Twitter / X" value={form.socialLinks.twitter} onChange={(v) => handleSocialChange('twitter', v)} />
            <Field label="LinkedIn" value={form.socialLinks.linkedin} onChange={(v) => handleSocialChange('linkedin', v)} placeholder="https://linkedin.com/company/..." />
          </div>
        </div>

        <div className="flex justify-end">
          <Button loading={saving} type="submit">
            <Save size={18} />
            Save Changes
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ContactInfo;
